// extracted by mini-css-extract-plugin
module.exports = {"player":"StartPlayer_player__qmBKD"};